import $ from 'jquery';

export default function setReturnUrls($container) {
  $container
    .find('[data-auto-return]')
    .each((_, link) => {
      const $link = $(link);

      if ($link.data('auto-return')) {
        $link.prop('href', `${$link.attr('href')}?returnUrl=${encodeURIComponent(document.location.href)}`);
      }
    });
}
